import { Component } from '@angular/core';
import { AccordionContentComponent } from '../accordion_content.component';
import { REDCRSS_EVENTS } from '../../../../../../shared/services/constants/redcross_evemts';

@Component({
  selector: 'yi-install-conversion-tracking',
  template: require('./install_conversion_tracking.component.html'),
  styles: [require('./install_conversion_tracking.component.scss')]

})

export class InstallConversionTrackingComponent extends AccordionContentComponent {

  navigateToCheckoutPage() {
    this.redcrossService.track(REDCRSS_EVENTS.CTA_CLICK, {
      ctaType: 'URL',
      ctaLocation: this.translatedTitle(this.item),
      ctaURL: this.item.getData().checkoutEditPage
    });
    this.redirectService.redirectTo(this.item.getData().checkoutEditPage, true);
  }
}
